var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.688,
    height: 76.688,
    viewBox: "0 0 76.688 76.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8280",
    "data-name": "Rectangle 8280",
    width: 38.224,
    height: 27.501,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16056",
    "data-name": "Group 16056",
    transform: "translate(-5263 6868)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8872",
    "data-name": "Rectangle 8872",
    width: 62,
    height: 62,
    transform: "translate(5280.089 -6868) rotate(16)",
    fill: "#19956a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16052",
    "data-name": "Group 16052",
    transform: "translate(5283 -6844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15935",
    "data-name": "Group 15935",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33632",
    "data-name": "Path 33632",
    d: "M0,13.374a3.374,3.374,0,0,1,.978-1.843,3.033,3.033,0,0,1,4.348.221q4.057,4.047,8.1,8.106a4.322,4.322,0,0,1,.32.423c.161-.2.243-.329.347-.434q9.4-9.4,18.794-18.8a3.074,3.074,0,0,1,3.3-.882,3.03,3.03,0,0,1,1.418,4.682,6.7,6.7,0,0,1-.47.53Q26.62,15.9,16.1,26.421a3,3,0,0,1-3.321.892,3.572,3.572,0,0,1-1.267-.818C8,23.009,4.5,19.5.994,16A3.688,3.688,0,0,1,0,14.121Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_Icon.582727d2b120ddb832e906d939bd3521.svg";
export { ForwardRef as ReactComponent };